import { ListOrgFunctionsRequestSchema, ListOrgFunctionsResponseSchema } from './list-org-functions.schema';
/**
 * List OrgFunctions Endpoint Contract
 * Retrieves all OrgFunctions in the organization (optionally filtered by kind)
 */ export const listOrgFunctionsContract = {
    method: 'GET',
    path: '/api/v2/org-function',
    description: 'Retrieve all OrgFunctions in the organization',
    requestSchema: ListOrgFunctionsRequestSchema,
    responseSchema: ListOrgFunctionsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated'
        }
    }
};

//# sourceMappingURL=list-org-functions.contract.js.map